import React, { useEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom';
import { useDispatch } from 'react-redux';
import PublishIcon from '@mui/icons-material/Publish';
import { useDragDropScreenReducer } from '@/main/store/dragDropScreen/dragDropScreenHooks';
import { changeDragDropScreen } from '@/main/store/dragDropScreen/dragDropScreenActions';
import { getTranslateByKey } from '@/main/services/utils';
import * as S from './styles';

interface IDragDropProps {
  children: React.ReactNode;
  onCustomDrop: (event: React.DragEvent<HTMLDivElement>) => void;
}

function KOGDragDropScreen({
  children,
  onCustomDrop
}: IDragDropProps) {
  const dispatch = useDispatch();
  const { dragDropScreen: dragDropScreenReducer } = useDragDropScreenReducer();
  const refContainer = useRef<HTMLDivElement>(null);
  const [isDragging, setIsDragging] = useState(false);

  function handleDrop(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    setIsDragging(false);
    dispatch(changeDragDropScreen(false))
    onCustomDrop(event)
  };

  function handleDragOver(event: React.DragEvent<HTMLDivElement>) {
    event.preventDefault();
    event.stopPropagation();
  };

  function handleDragLeave(event: React.DragEvent<HTMLDivElement>) {
    setIsDragging(false);
    dispatch(changeDragDropScreen(false))
  };
  useEffect(() => {
    if (dragDropScreenReducer.data) { setIsDragging(true) }
  }, [dragDropScreenReducer.data])

  return (
    <>
      {children}
      {createPortal(
        <S.Container
          id='id-dragDrop-btn-file'
          ref={refContainer}
          onDrop={handleDrop}
          onDragEnter={handleDragOver}
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          $isDragging={isDragging}
        >
          <S.WrapperInfo>
            <PublishIcon />
            <S.TitleDragDrop>{getTranslateByKey('information.inputFile')}</S.TitleDragDrop>
            <S.TextDragDrop>{getTranslateByKey('information.dragDropHere')}</S.TextDragDrop>
          </S.WrapperInfo>
        </S.Container>
        ,
        document.body
      )}
    </>
  )
}

export default KOGDragDropScreen;